var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-icon",
    d: "M25.856.4l-1.465,3.1-3.277.5a.76.76,0,0,0-.4,1.28L23.088,7.7l-.561,3.41a.724.724,0,0,0,1.041.79l2.932-1.61,2.932,1.61a.725.725,0,0,0,1.041-.79L29.911,7.7l2.371-2.414a.76.76,0,0,0-.4-1.28l-3.277-.5L27.143.4a.705.705,0,0,0-1.287,0Z",
    transform: "translate(-20.5 0.013)",
    fill: "#ffd438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.fa5c49b9d78d8130b3e8c097f022cae2.svg";
export { ForwardRef as ReactComponent };